import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from '../Services/cookie';
import { AccountService } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { InsuranceService } from '../Services/insurance.service';

@Component({
  selector: 'app-insurance-benefits-documents',
  templateUrl: './insurance-benefits-documents.component.html',
  standalone:false,
  styleUrls: ['./insurance-benefits-documents.component.scss']
})
export class InsuranceBenefitsDocumentsComponent implements OnInit {


  accordionItem: number = 1;
  proposalId: string;
  BenefitsDoc: any;
  Benefits: any;

  constructor(private router: Router, private acct: AccountService, private insurance: InsuranceService, private common: CommonService, private cookieService: CookieService,
    public auth: AuthService) { }

  async ngOnInit(): Promise<any> {

    this.common.presentLoading();
    this.auth.accessToken = await this.common.Get("token");


    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {
        this.insurance.GetBenefitsAndDoc(this.proposalId, this.auth.accessToken).then((res: any) => {
          if (res?.response?.code == 1) {
            this.Benefits = res.response.content.benefits;
            this.BenefitsDoc = res.response.content.documents;
            console.log("this.Benefits", this.Benefits);
            console.log("this.BenefitsDoc", this.BenefitsDoc);
            this.common.hideLoading();
            //  this.cookieService.delete("proposalId");
    
          }
          else {
            this.common.hideLoading();
            this.common.ParseErrorAlert("", "OK", this.router, res);
          }
        })
      } else {
        await this.common.hideLoading();

        this.common.ParseErrorAlert("", "", this.router, data);
      }
    })
    let a =await this.cookieService.get("proposalId", false);

    if (a) {

      this.proposalId = a;

    }
   

  }

  showAccordion(e) {
    if (this.accordionItem == e) {
      this.accordionItem = null;
    } else {
      this.accordionItem = e;
    }
  }

  ViewPDF(documentId) {

    this.common.presentLoading();
    this.insurance.GetDocument(this.proposalId, documentId, "VIEW", this.auth.accessToken).then((res: any) => {
      if (res?.response?.code == 1) {
        let pdf = res.response.content.docuemnt;

        // window.location.href = pdf;

        //  window.open(pdf, '_self');
         window.open(pdf);

        console.log("pdf", pdf);
        this.common.hideLoading();
        this.cookieService.delete("proposalId");

      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert("", "OK", this.router, res);
      }
    })
  }

}
